import {
  arbitrum,
  base,
  baseSepolia,
  mainnet,
  optimism,
  sepolia,
  zora,
  zoraSepolia,
} from '@ourzora/chains'
import { cleanAddress } from '../../addresses'
import abi from './abi'

// https://docs.uniswap.org/contracts/v3/reference/deployments/

export const UniswapQuoter = {
  abi,
  address: {
    [mainnet.id]: cleanAddress('0x61fFE014bA17989E743c5F6cB21bF9697530B21e'),
    [sepolia.id]: cleanAddress('0xEd1f6473345F45b75F8179591dd5bA1888cf2FB3'),
    [zora.id]: cleanAddress('0x11867e1b3348F3ce4FcC170BC5af3d23E07E64Df'),
    [zoraSepolia.id]: cleanAddress('0xC195976fEF0985886E37036E2DF62bF371E12Df0'),
    [base.id]: cleanAddress('0x3d4e44Eb1374240CE5F1B871ab261CD16335B76a'),
    [baseSepolia.id]: cleanAddress('0xC5290058841028F1614F3A6F0F5816cAd0df5E27'),
    [optimism.id]: cleanAddress('0x61fFE014bA17989E743c5F6cB21bF9697530B21e'),
    [arbitrum.id]: cleanAddress('0x61fFE014bA17989E743c5F6cB21bF9697530B21e'),
  } as const,
} as const
